import { refreshMunicipalPropertyManagement } from "@/domain/municipal-property/lib/refresh-municipal-property-management";
import { UpdateMunicipalPropertyMutation } from "@/graphql/generated/graphql";
import { UpdateMunicipalPropertyInput } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { QueryClient, useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";

import { UPDATE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT } from "./update-municipal-property-mutation.gql";

export function useUpdateMunicipalProperty(
  workspaceId: string,
): UseMutationResult<UpdateMunicipalPropertyMutation, Error, UpdateMunicipalPropertyInput> {
  const queryClient: QueryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: UpdateMunicipalPropertyInput): Promise<UpdateMunicipalPropertyMutation> =>
      createOperationClient("UpdateMunicipalProperty").request(UPDATE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT, { input }),
    onSuccess: (_response: UpdateMunicipalPropertyMutation, input: UpdateMunicipalPropertyInput): Promise<void> =>
      refreshMunicipalPropertyManagement({ queryClient, scope: { workspaceId, propertyIdList: [input.id] } }),
  });
}
